export default __webpack_public_path__ + "static/media/cake.df6470a8.png";